var VehiclesModalController = /** @class */ (function () {
    function VehiclesModalController($scope, $mdDialog, vehicles, $ionicPopup, $interpolate, options, $translationService) {
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.vehicles = vehicles;
        this.$ionicPopup = $ionicPopup;
        this.$interpolate = $interpolate;
        this.confirmText = $translationService.getTranslation('OK');
        this.dismissText = $translationService.getTranslation('Cancel');
        this.contextMessage = options.contextMessage;
        this.title = options.title;
        if (options.confirmText) {
            this.confirmText = options.confirmText;
        }
        if (options.dismissText) {
            this.dismissText = options.dismissText;
        }
        if (this.vehicles.length > 0) {
            this.selectedId = this.vehicles[0].Id;
        }
    }
    VehiclesModalController.prototype.selectVehicle = function (vehicle) {
        var _this = this;
        if (vehicle.ChargedByAnotherUser && vehicle.Charging) { //show message if vehcile was charging by other user
            //Build Error message
            var message = 'The vehicle {{vehicleName}} is currently being charged by {{chargedBy}}. Do you want to disconnect it to be able to charge it under your account?';
            var scope = this.$scope.$new(true);
            scope.vehicleName = vehicle.Name;
            scope.chargedBy = vehicle.ChargedBy;
            var template = this.$interpolate(message)(scope);
            this.$ionicPopup.confirm({
                template: template,
                cssClass: 'reserved-confirm',
                buttons: [
                    {
                        text: 'Yes',
                        type: 'button-positive',
                        onTap: function(e) {
                            // Returning a value will cause the promise to resolve with the given value.
                            return true;
                        }
                    },
                    {
                        text: 'No' 
                    }
                ]
            }).then(function (result) {
                if (result) {
                    _this.$mdDialog.hide(vehicle);
                }
            });
        }
        else {
            this.$mdDialog.hide(vehicle);
        }
    };
    VehiclesModalController.prototype.onOK = function () {
        var _this = this;
        var selected = _.find(this.vehicles, function (v) {
            return v.Id === _this.selectedId;
        });
        this.selectVehicle(selected);
    };
    VehiclesModalController.prototype.closeDialog = function () {
        this.$mdDialog.cancel();
    };
    VehiclesModalController.inject = ['$scope', '$mdDialog', 'vehicles', '$ionicPopup', '$interpolate', "options", "$translationService"];
    return VehiclesModalController;
}());
